import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4a6a4a',
      dark: '#3a5a3a',
      light: '#5a7a5a',
    },
    secondary: {
      main: '#6a8a6a',
      light: '#8a9a8a',
    },
    text: {
      primary: '#2d4a2d',
      secondary: '#4a5f4a',
      disabled: '#6a7f6a',
    },
    background: {
      default: '#f5faf5',
      paper: '#e8f3e8',
    },
  },
  typography: {
    fontFamily: 'var(--font-main)',
    h1: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 500,
      letterSpacing: '-0.5px',
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: 'var(--font-main)',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: 'var(--font-main)',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h6: {
      fontFamily: 'var(--font-main)',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    body1: {
      fontFamily: 'var(--font-main)',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: 'var(--font-main)',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    button: {
      fontFamily: 'var(--font-main)',
      fontWeight: 400,
      lineHeight: 1.6,
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          border: 'none !important',
          outline: 'none !important',
          overflow: 'hidden',
          '&::before': {
            display: 'none',
          },
          '&::after': {
            display: 'none',
          },
          '& .MuiButtonBase-root': {
            overflow: 'hidden',
            borderRadius: '8px',
          },
          '& .MuiButton-label': {
            borderRadius: '8px',
          },
          '& .MuiTouchRipple-root': {
            borderRadius: '8px',
          },
        },
        contained: {
          boxShadow: '0 4px 14px rgba(74, 106, 74, 0.4)',
          '&:hover': {
            boxShadow: '0 6px 20px rgba(74, 106, 74, 0.5)',
          },
          '& .MuiButtonBase-root': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '8px',
            overflow: 'hidden',
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
            },
            '&.Mui-focused': {
              backgroundColor: 'white',
              boxShadow: 'none !important',
              outline: 'none !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '8px',
            },
            '& .MuiOutlinedInput-input': {
              borderRadius: '8px',
            },
            '& fieldset': {
              boxShadow: 'none',
            },
          },
        },
      },
    },
  },
});

export default theme;

